import React from 'react';
import './CategoryDropdown.scss';
import { Icon } from 'antd';
import PriceItem from 'Components/Shared/PriceItem/PriceItem';
import OutsideClickHandler from 'Components/Shared/OutsideClickHandler/OutsideClickHandler';

type Category = Julius.Website.PriceCategoryViewModel | Julius.Website.SectionCategoryViewModel | Julius.Website.PriceDiscountViewModel;

interface IProps {
  categories: Category[];
  selectedCategoryID: number;
  onSelect: (id: number) => void;
}

interface IState {
  isOpen: boolean;
}

class CategoryDropdown extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      isOpen: false,
    }
  }

  toggleDropdown = () => {
    this.setState({ isOpen: !this.state.isOpen });
  }

  hideDropdown = () => {
    this.setState({ isOpen: false });
  }

  onSelectCategory = (id: number) => {
    this.setState({ isOpen: false }, 
      () => this.props.onSelect(id));
  };

  // Refactory any type
  getCategoryLabel = (category: any) => {
    if ( category.priceDiscounts ) {
      if ( category.priceDiscounts.length > 0 ) {
        if ( category.price !== category.priceDiscounts[0].price ) {
          return (
            <>
              { category.name && <span>{ category.name }</span> }
              { 
                category.price > 0 && (
                  <> - <PriceItem price={ category.price } decimals={ 0 } style="medium-bold overline"/> <PriceItem price={ category.priceDiscounts[0].price } decimals={ 0 } style="medium-bold price reduced"/></>) 
              }
            </>
          );
        }
      }
    }
    return (
      <>
        { category.name && <span>{ category.name }</span> }
        { category.price > 0 && <> - <PriceItem price={ category.price } decimals={ 0 } /></> }
      </>
    );
  }

  getSelectedCategoryLabel = () => {
    const { categories, selectedCategoryID } = this.props;

    let selectedCategory = categories.find(c => c.id === selectedCategoryID);

    if (!selectedCategory) {
      selectedCategory = categories[0];
    }
    return this.getCategoryLabel(selectedCategory);
  }

  render() {
    const { categories } = this.props;

    if (!categories || !categories.length) {
      return null;
    }
    
    const { isOpen } = this.state;
    const dropdownStyle = categories.length === 1 ? 
      'category-dropdown disabled' : 'category-dropdown';

    return (
      <OutsideClickHandler style={ dropdownStyle } onOutsideClick={ this.hideDropdown }>
          <div className='selected-item'>
            <span className='value'>
              { this.getSelectedCategoryLabel() }
            </span>
            <div className='icon-container' onClick={ this.toggleDropdown }>
              <Icon type={ isOpen ? 'caret-up' : 'caret-down' } /> 
            </div>
          </div>
          { isOpen &&
            <div className='dropdown-items'>
              { categories.map((c, i) =>
                <div key={ i } onClick={ () => this.onSelectCategory(c.id) }>
                  { this.getCategoryLabel(c) }
                </div>)
              }
            </div>
          }
      </OutsideClickHandler>
    );
  }
}

export default CategoryDropdown;


// WEBPACK FOOTER //
// ./src/components/CategoryDropdown/CategoryDropdown.tsx